import * as athlete from "./athlete/index.js";
import * as coach from "./coach/index.js";
import * as feedback from "./feedback/index.js";
import * as invitationLink from "./invitationLink/index.js";
import * as parent from "./parent/index.js";
import * as passwordLink from "./passwordLink/index.js";
import * as profile from "./profile/index.js";
import * as squad from "./squad/index.js";
import * as trainingSession from "./trainingSession/index.js";
import * as user from "./user/index.js";
import * as weeklySchedule from "./weeklySchedule/index.js";
import * as textblocks from "./textblocks/index.js";

const httpService = { athlete, coach, feedback, invitationLink, parent, passwordLink, profile, squad, textblocks, trainingSession, user, weeklySchedule }

export default httpService;